import { render, staticRenderFns } from "./LocationClientsAccountSummaryDashboard.vue?vue&type=template&id=0f50f968&"
import script from "./LocationClientsAccountSummaryDashboard.vue?vue&type=script&lang=js&"
export * from "./LocationClientsAccountSummaryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports